import { createAsyncThunk } from "@reduxjs/toolkit";
import { bannerAdCampaignService } from "../../services";

const createMessage = createAsyncThunk(
    'bannerAdCampaign/createMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await bannerAdCampaignService.createMessage(
                payload.companyId,
                payload.campaignId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateMessage = createAsyncThunk(
    'bannerAdCampaign/updateMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await bannerAdCampaignService.updateMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteMessage = createAsyncThunk(
    'bannerAdCampaign/deleteMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await bannerAdCampaignService.deleteMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getMessage = createAsyncThunk(
    'bannerAdCampaign/getMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await bannerAdCampaignService.getMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignEchos = createAsyncThunk(
    'bannerAdCampaign/getCampaignEchos',
    async (payload, ThunkAPI) => {
        try{
            const response = await bannerAdCampaignService.getCampaignEchos(
                payload.companyId,
                payload.campaignId, 
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
}